<div class="dialog-container">
  <h1 mat-dialog-title>{{ 'SELECT_LOCATION_POINT' | translate }}</h1>
  <div mat-dialog-content class="dialog-content">
    <sc-super-search
      (itemSelected)="selectStation($event)"
      styleClass="station-search-simple"
      (clear)="clearSearch()"
      [enter]="false"></sc-super-search>
  </div>
  <div mat-dialog-actions>
    <button
      mat-raised-button
      [disabled]="!station"
      color="primary"
      (click)="dialogRef.close(station)">
      {{ buttonText || ('SELECT' | translate) }}
    </button>
    <button mat-raised-button (click)="dialogRef.close()">
      {{ 'CANCEL' | translate }}
    </button>
  </div>
</div>
